<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Tickets</strong>
          </div>

          <b-row class="mb-2">
            <b-col sm="3">
              <b-form-group>
                <label for="empresa">Buscar</label>
                <b-form-input
                  id="filtro"
                  name="filtro"
                  type="text"
                  v-model="filtroEt.filtro"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!--desde-->
            <b-col md="3">
              <b-form-group label="Fecha inicio">
                <el-date-picker id="from"
                  name="from"
                  type="date"
                  class="w-100"
                  v-model="filtroEt.desde"
                  value-format="yyyy-MM-dd"
                />
              </b-form-group>
            </b-col>

            <!--hasta-->
            <b-col md="3">
              <b-form-group label="Fecha fin">
                <el-date-picker id="to"
                  name="to"
                  type="date"
                  class="w-100"
                  v-model="filtroEt.hasta"
                  value-format="yyyy-MM-dd"
                />
              </b-form-group>
            </b-col>

            <b-col v-if="usuarioAdmin" sm="3">
              <label for="empresa">Empresa</label>
              <br />
              <el-select
                id="empresa"
                name="empresa"
                v-model="filtroEt.empresa"
                filterable
                remote
                clearable
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
                :remote-method="getEmpresas"
                @change="changeCompanySelected()"
              >
                <el-option
                  class="width-select-options"
                  v-for="item in empresas"
                  :key="item.id"
                  :label="item.nombre"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </b-col>

            <b-col v-if="filtroEt.empresa && allCountries.length >= 1" sm="3">
              <b-form-group>
                <label for="country">País</label>
                <el-select
                  id="country"
                  name="country"
                  v-model="country_id"
                  filterable
                  clearable
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                >
                  <el-option
                    v-for="item in allCountries"
                    :key="item.country.id"
                    :label="item.country.name"
                    :value="item.country.id"
                  />
                </el-select>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="filtroEt.empresa">
              <b-form-group>
                <label for="ubicacion" class="w-100">
                  Ubicaciones
                  <b-form-checkbox
                    v-model="filtroEt.digit_location"
                    class="float-right"
                    @change="resetSelectedLocation"
                    :disabled="!filtroEt.empresa && usuarioAdmin"
                    v-b-tooltip.top.hover="'Ubicación temporal'"
                    :value="true"
                    :unchecked-value="false"
                  />
                </label>
                <b-form-input
                  v-if="filtroEt.digit_location"
                  :disabled="!filtroEt.empresa && usuarioAdmin"
                  v-model="filtroEt.ubicacion_diligenciada"
                />
                  <Treeselect v-else :value="value" name="slq_locations_id" id="slq_locations_id" clearable
                    :options="treeWithChildrens" :normalizer="normalizer" placeholder="Seleccionar"
                    :flatten-search-results="true" :multiple="true" v-validate="'required'" data-vv-as=" " :disable-branch-nodes="true"
                    v-model="filtroEt.slq_locations_id" :defaultExpandLevel="Infinity"
                    no-results-text="No se encontraron resultados." :max-height="300" class="custom-treeselect"
                    value-consists-of="ALL_WITH_INDETERMINATE" :show-count="true" noOptionsText="No hay resultados para mostrar">
                  </Treeselect>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group>
                <label for="estado">Estado</label>
                <el-select
                  v-model="filtroEt.estado"
                  filterable
                  clearable
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                >
                  <el-option
                    v-for="estados in estadosBusqueda"
                    :key="estados.value"
                    :label="estados.text"
                    :value="estados.value"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3" v-if="usuarioAdmin">
              <b-form-group>
                <label for="estado">Profesional</label>
                <el-select
                  v-model="filtroEt.id_responsable"
                  filterable
                  clearable
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                >
                  <el-option
                    v-for="usuario in usuarios"
                    :key="usuario.value"
                    :label="usuario.text"
                    :value="usuario.value"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>


            <b-col sm="3">
              <b-form-group>
                <label for="type_matter" class="w-100">
                  Asunto
                </label>
                <treeselect
                  placeholder="Tipos de asunto"
                  :options="typesOfMatters"
                  :searchable="true"
                  :multiple="true"
                  v-model="filtroEt.type_matter"
                >
                </treeselect>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group>
                <label for="manufracturer_id" class="w-100">
                  Fabricantes
                </label>
                <el-select
                  id="manufacturer_id"
                  name="manufacturer_id"
                  filterable
                  placeholder="Buscar fabricante"
                  v-model="filtroEt.manufacturer_id"
                  no-data-text="No hay datos que coincidan"
                  no-match-text="No hay datos que coincidan"
                  :remote-method="getProducerByName"
                  remote
                  clearable
                  multiple
                >
                  <el-option
                    v-for="item in producers"
                    :key="item.id"
                    :label="item.nombre"
                    :value="item.id"
                  />
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Acciones de busqueda y creacion de ítems  -->
          <b-row class="mb-2">
            <b-col md="6">
                <b-button class="mx-1" variant="primary" @click.prevent="buscador(filtroEt)">
                  <i class="fa fa-search fa-lg"></i>
                  <span class="d-md-inline-block"> Buscar</span>
                </b-button>
                <b-button class="mx-1" @click.prevent="limpiar()">
                  <i class="fa fa-eraser fa-lg"></i>
                  <span class="d-md-inline-block"> Limpiar</span>
                </b-button>
            </b-col>

          </b-row>

          <!-- Acciones de los administradores -->
          <b-row class="mb-2">
            <b-col class="mt-2 mt-md-0" md="12">
                <template v-if="usuarioAdmin">
                 <!--  <b-button variant="info" class="float-md-right mx-1" @click="mostrarModalAgendamientos">
                  <i class="fa fa-list" />
                  Consultar tickets procesados
                </b-button> -->
                  <b-dropdown
                  :disabled="!ticketsSeleccionados.length"
                  id="accionesMasivo"
                  text="Opciones"
                  class="float-md-right mx-1"
                  variant="primary"
                >
                  <b-dropdown-item
                    @click="mostrarModalAccionesMasivas"
                    :disabled="!ticketsSeleccionados.length"
                  >
                    <i class="fa fa-tasks"> </i>
                    Acciones masivas
                  </b-dropdown-item>
                  <!-- <b-dropdown-item
                    @click="exportTickets"
                    :disabled="!ticketsSeleccionados.length"
                  >
                    <i class="fa fa-download" />
                    Exportar tickets
                  </b-dropdown-item> -->
                </b-dropdown>
                </template>
                <b-dropdown
                  v-if="permissions.includes('tickets-descarga-masiva')"
                  id="descargaMasivaTickets"
                  text="Descarga masiva"
                  class="float-md-right mx-1"
                  variant="info"
                >
                  <b-dropdown-item @click="modalDescargaMasiva = true">
                    <i class="fa fa-file-archive-o" />
                    Agendar
                  </b-dropdown-item>
                  <b-dropdown-item @click="verAgendadosDescargaMasiva">
                    <i class="fa fa-list" />
                    Ver agendados
                  </b-dropdown-item>
                </b-dropdown>
                <b-button class="float-md-right mx-2"
                          v-if="permissions.includes('ver-graficas-tickets')"
                          :disabled="!filtroEt.empresa"
                          @click="toggleAccordionGraphics"
                          variant="primary">
                <i class="fa fa-pie-chart fa-lg"></i>
                <span class="ml-2 d-none d-md-inline-block"> {{ acordeonVisible ? 'Ocultar' : 'Ver' }} graficas</span>
              </b-button>
              <b-button
                  v-if="!usuarioAdmin"
                  variant="primary"
                  class="pull-right float-right"
                  v-b-modal.modal-1
              >
                <i class="fa fa-plus fa-lg"></i> Nuevo Ticket
              </b-button>
            </b-col>
          </b-row>

          <!-- Graficas -->
          <b-row class="mt-4" v-if="permissions.includes('ver-graficas-tickets')">
            <b-col sm="12">
              <b-collapse v-model="acordeonVisible" :visible="false" accordion="my-accordion" role="tabpanel">
                <b-card>

                  <column-chart :data="tickets_chart" :colors="colorsGphrafics"/>

                </b-card>
              </b-collapse>
            </b-col>
          </b-row>

          <!-- Tabla de tickets -->
          <div>
            <b-collapse visible>
              <b-table
                bordered
                responsive
                striped
                hover
                small
                :items="tickets.data"
                :fields="columnas"
                :tbody-tr-class="unClass"
                empty-text="No hay información para mostrar"
                show-empty
                thead-tr-class="table-active"
              >
                <template #head(marcar) v-if="usuarioAdmin">
                  <el-checkbox
                    :value="marcadosPagina"
                    @change="setMarcarDesmarcarTodos"
                  ></el-checkbox>
                </template>

                <!-- Columna tipos de asuntos -->
                <template v-slot:cell(type_matter)="data">
                  {{ getNameTypeMatter(data.item.type_matter) }}
                </template>

                <!-- Columna tipos de asuntos -->
                <template v-slot:cell(manufacturer)="data">
                  {{ (data.item.manufacturer && typeof data.item.manufacturer === 'object') ? data.item.manufacturer.nombre : 'No registra'  }}
                </template>

                <template v-slot:cell(profesional)="data">
                  {{ data.item.profesional.name }}
                </template>
                <template v-slot:cell(marcar)="data" v-if="usuarioAdmin">
                  <el-checkbox
                    :value="ticketMarcado(data.item)"
                    @change="seleccionarTicket(data.item.id, $event)"
                  ></el-checkbox>
                </template>
                <template v-slot:cell(status)="data">
                  {{ data.item.estado_ticket.lista }}
                </template>
                <template v-slot:cell(locations)="data">
                  <div v-if="data.item.list_locations && typeof data.item.list_locations === 'object' && data.item.list_locations.length > 0">
                    <span v-for="(location, index) of data.item.list_locations" :key="location.id" class="mb-1">
                      <span>{{ location.description }}</span>
                      <span class="mx-1" v-show="index < (data.item.list_locations.length-1)">|</span>
                    </span>
                  </div>
                  <span v-else-if="data.item.temporary_location">
                    * {{ data.item.temporary_location.name }}
                  </span>
                  <span v-else-if="data.item.ubicacion_diligenciada">
                    * {{ data.item.ubicacion_diligenciada }}
                  </span>
                  <span v-else>
                    No registra
                  </span>
                </template>
                <template v-slot:cell(actions)="data">
                  <i
                    @click="verDetalle(data.item)"
                    class="fa fa-edit fa-lg option"
                  ></i>
                </template>
              </b-table>

              <!-- paginación -->
              <el-pagination
                :total="tickets.total"
                v-model="filtroEt.page"
                @size-change="setPerPagePagination"
                @current-change="setPagePagination"
                :current-page="filtroEt.page"
                small
                :page-sizes="[10, 30, 50, 100]"
                :page-size="filtroEt.perPage"
                class="float-right"
                layout="total, sizes, prev, pager, next"
              />
            </b-collapse>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal acciones a items en masivo -->
    <b-modal
      ref="modal_acciones_masivo"
      hide-footer
      size="lg"
      @hide="limpiarObservaciones"
    >
      <template #modal-title>
        <strong class="ml-2">{{ accionesMasivoTitulo }}</strong>
      </template>
      <ModalAccionesMasivo
        :modal="modal"
        @cerrarModal="cerrarModal"
      ></ModalAccionesMasivo>
    </b-modal>

    <!-- Modal reportes agendados -->
    <b-modal
      class="modal"
      hide-footer
      v-model="modalReportes"
      size="xl"
      :title="'Reportes agendados'"
    >
      <TicketsAgendados></TicketsAgendados>
    </b-modal>

    <!-- Modal solicitud de descarga masiva -->
    <b-modal
      class="modal"
      hide-footer
      v-model="modalDescargaMasiva"
      size="lg"
      title="Descarga masiva de tickets"
    >
      <TicketsDescargaMasiva @agendado="onDescargaMasivaAgendada"></TicketsDescargaMasiva>
    </b-modal>

    <!-- Modal de seguimiento de descargas masivas -->
    <b-modal
      class="modal"
      hide-footer
      v-model="modalDescargaMasivaListado"
      size="xl"
      title="Descargas masivas de tickets"
    >
      <TicketsDescargaMasivaListado
        v-if="descargaMasivaCompanyId"
        :company-id="descargaMasivaCompanyId"
      ></TicketsDescargaMasivaListado>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { getAcls } from "../../plugins/acl";
import Treeselect from "@riophae/vue-treeselect";
import ModalAccionesMasivo from "./ModalAccionesMasivo.vue";
import TicketsAgendados from './TicketsAgendados.vue';
import TicketsDescargaMasiva from './TicketsDescargaMasiva.vue';
import TicketsDescargaMasivaListado from './TicketsDescargaMasivaListado.vue';
import Swal from "sweetalert2";
import useCompanyCountries from '../../composables/country/useCompanyCountries'
import useCompanyLocationsTree from '../../composables/location/useCompanyLocationsTree'

export default {
  name: "buscador-tickets",
  mixins: [useCompanyCountries, useCompanyLocationsTree],
  components: {
    ModalAccionesMasivo,
    Treeselect,
    TicketsAgendados,
    TicketsDescargaMasiva,
    TicketsDescargaMasivaListado
  },
  data() {
    return {
      value: null,
      val: null,
      country_id: null,
      reset: false,
      modalReportes: false,
      modalDescargaMasiva: false,
      modalDescargaMasivaListado: false,
      descargaMasivaCompanyId: null,
      modal: 1,
      accionesMasivoTitulo: "",
      loading: false,
      opcionesPerPage: [
        { value: "10", text: 10 },
        { value: "20", text: 20 },
        { value: "30", text: 30 },
        { value: "40", text: 40 },
        { value: "50", text: 50 },
      ],
      listaEmpresas: [],
      mostrar: false,
      columnas: [
        {
          key: "idTicket",
          label: "Id",
          sortable: true,
          thStyle: { "min-width": "70px !important" },
        },
        {
          key: "empresa",
          label: "Empresa",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "type_matter",
          label: "Asunto",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "asunto",
          label: "Nombre del producto/# Solicitud",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "status",
          label: "Estado",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "manufacturer",
          label: "Fabricante",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "locations",
          label: "Ubicaciones",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "profesional",
          label: "Profesional",
          sortable: true,
          thStyle: { "min-width": "140px !important" },
        },
        {
          key: "created_at",
          label: "Fecha generación",
          sortable: true,
          thStyle: { "min-width": "100px !important" }
        },
        {
          key: "actions",
          label: "Ver",
          thStyle: { "min-width": "70px !important", width: "80px !important" },
        },
      ],
      acordeonVisible : false,
      permissions: [],
      colorsGphrafics: ['rgba(200, 100, 100, 0.7)', 'rgba(100, 150, 200, 0.7)', 'rgba(255, 220, 150, 0.7)', 'rgba(150, 200, 180, 0.7)']
    };
  },
  async created() {
    const acls = getAcls();
    const roles = acls.roles;
    this.permissions = acls.permisos;
    if (roles.some(rol => rol == 'superadmin' || rol == 'admin' || rol == 'admin-tecnico')) {
      let marcar = {
        key: "marcar",
        label: "",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { "max-width": "50px", width: "50px !important" },
      };
      this.columnas.unshift(marcar);
      this.columnas = this.columnas.filter(x => x.key !== 'locations')
    } else {
      await this.loadCompanyGeo({ company_id: acls.empresa, country_id: null });
    }

    await this.listarTickets();
    await this.getEstados();
    await this.getUsuarios();
    await this.checkPermissions().then(()=>{
        if(this.selectedCompany && this.usuarioAdmin){
            this.filtroEt.empresa = this.selectedCompany.id;
            if(!this.usuarioAdmin)this.setEmpresas([this.selectedCompany]);
            this.setSelectedCompany(null);
        }
    })

  },
  beforeMount() {
    this.setDefaultTicketsSeleccionados();
  },
  methods: {
    async checkPermissions() {
      if (this.permissions.includes('obtener-mi-empresa')) {
        if(!this.usuarioAdmin) {
          await this.getMyCompany().then(async (company) => {
            this.filtroEt.empresa = company.id
          })
        }
      }
    },
    async toggleAccordionGraphics() {
      this.acordeonVisible = !this.acordeonVisible;
      if (this.filtroEt.empresa && this.acordeonVisible) {
        await this.geTicketInfoForGraphs(this.filtroEt).then(async () => {
          this.setColorsGphrafics();
        });
      }
    },
    async mostrarModalAgendamientos() {
      await this.getTicketsReports();
      this.modalReportes = true;
    },
    onDescargaMasivaAgendada(empresaId) {
      this.modalDescargaMasiva = false;
      this.descargaMasivaCompanyId = empresaId;
      this.modalDescargaMasivaListado = true;
    },
    verAgendadosDescargaMasiva() {
      if (!this.filtroEt.empresa) {
        this.$alertError("Seleccione una empresa en los filtros para ver sus descargas agendadas", 3000, false, "Atención", "warning");
        return;
      }
      this.descargaMasivaCompanyId = this.filtroEt.empresa;
      this.modalDescargaMasivaListado = true;
    },
    async exportTickets() {
      if (this.ticketsSeleccionados) {
        const acls = getAcls();

        await this.fetchTicketsReport({idTickets: this.ticketsSeleccionados, uuid: acls.uuid, confecha: this.filtroEt.confecha});
        await this.getTicketsReports();
        this.modalReportes = true;
        this.setDefaultTicketsSeleccionados();
      }
    },
    resetSelectedLocation() {
      this.setFiltro({
        ubicacion_diligenciada: "",
        slq_locations_id: null,
      });
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: Array.isArray(node.children) && node.children.length ? node.children : undefined,
        raw: node,
      };
    },
    async cargarUbicaciones() {
      if (this.filtroEt.empresa) {
        await this.arbolUbicacionesEmpresa(this.filtroEt.empresa);
      }
    },
    limpiarObservaciones() {
      this.setPageMasivo(1);
      this.setMensajesMasivos({ data: [] });
    },
    cerrarModal() {
      this.$refs.modal_acciones_masivo.hide();
    },
    mostrarModal(modal) {
      this.modal = modal;
      if (modal == 1) {
        this.accionesMasivoTitulo = "Enviar mensaje";
      } else if (modal == 2) {
        this.accionesMasivoTitulo = "Asignar profesional";
      } else {
        this.accionesMasivoTitulo = "Cambiar estado";
      }
      this.$refs.modal_acciones_masivo.show();
    },
    mostrarModalAccionesMasivas() {
      this.accionesMasivoTitulo = "Acciones masivas";
      this.$refs.modal_acciones_masivo.show();
    },
    seleccionarTicket(id, state) {
      let data = {
        id: id,
        state: state,
      };
      this.setTicketsSeleccionados(data);
      this.setMarcarCheckTodos();
    },
    ticketMarcado(item) {
      return this.ticketsSeleccionados.some((t) => t == item.id);
    },
    async limpiar() {
      this.loading = true;
      const keepCompany = !this.usuarioAdmin;
      this.resetFiltro(keepCompany);
      this.setMarcarDesmarcarTodos(false);
      await this.buscador(this.filtroEt);
      this.loading = false;
    },
    /**
     * Metodo para hacer el filtro por el nombre de la empresa
     */

    async buscarEmpresa(query) {
      if (query.length >= 3) {
        this.listaEmpresas = this.empresas.filter((item) => {
          return item.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.listaEmpresas = [];
      }
    },

    async vistaAdmin() {
      await this.getProductos();
    },
    verDetalle(item) {
      if(!this.selectedCompany)this.updateSelectedCompany();
      this.$router.push({
        name: 'tickets-detalle',
        params: {id: item.id, company_id : item.id_empresa}
      })
    },

    unClass(item) {
      if (item) {
        if (item.color !== "") return item.color;
        return "";
      } else {
        return "";
      }
    },

    async buscador(buscar) {
      this.loading = true;
      buscar.page = 1;
      this.setFiltro(buscar);
      await this.listarTickets();
      if (this.filtroEt.empresa){
        await this.geTicketInfoForGraphs(this.filtroEt).then(async () =>{
            this.setColorsGphrafics();
        });
      }
      this.loading = false;
    },

    descargaAdjunto(adj) {
      window.open(process.env.VUE_APP_API_URL + "storage/files/" + adj.adjunto);
    },
    setColorsGphrafics(){
      if (this.filtroEt.estado == 0){
        this.colorsGphrafics = ['rgba(200, 100, 100, 0.7)', 'rgba(100, 150, 200, 0.7)', 'rgba(255, 220, 150, 0.7)', 'rgba(150, 200, 180, 0.7)'];
      } else if (this.filtroEt.estado == 173){
        this.colorsGphrafics = ['rgba(200, 100, 100, 0.7)'];
      } else if (this.filtroEt.estado == 174){
        this.colorsGphrafics = ['rgba(100, 150, 200, 0.7)'];
      } else if (this.filtroEt.estado == 175){
        this.colorsGphrafics = ['rgba(255, 220, 150, 0.7)'];
      } else if (this.filtroEt.estado == 176){
        this.colorsGphrafics = ['rgba(150, 200, 180, 0.7)'];
      }
    },
    /**
     * Obtener el nombre de los tipos de asuntos.
     *
     * @param String typeMatters
     * @returns
     */
    getNameTypeMatter(typeMatters) {
      // Si es nulo, retorna []
      if (!typeMatters) return [];

      // Si es un string, retorna el título
      if (typeof typeMatters === 'string') return this.getTitleTypeMatter(typeMatters);

      // Si es un array (por ejemplo, "[2]"), intenta parsear y retornar el título
      if (typeof typeMatters === 'object' || (typeof typeMatters === 'string' && typeMatters.startsWith('[') && typeMatters.endsWith(']'))) {
        let arr = typeMatters;
        if (typeof typeMatters === 'string') {
          try {
            arr = JSON.parse(typeMatters);
          } catch (e) {
            return "No registra";
          }
        }
        let typeMattersText = [];
        arr.forEach(type => {
          typeMattersText.push(this.getTitleTypeMatter(type));
        });
        return typeMattersText;
      }

      return "No registra";
    },

    getTitleTypeMatter(type) {
      const typeMatter = this.typesOfMatters.find(x => +x.id === +type)
      return typeMatter ? typeMatter.label : "No registra";
    },


    findLocationById(locations, id) {
      for (const location of locations) {
          if (location.id === id) return location;
          if (location.children && location.children.length > 0) {
              const result = this.findLocationById(location.children, id);
              if (result) return result;
          }
      }
      return null;
    },
    updateSelectedCompany(){
        const company = this.empresas.find(e => e.id === this.filtroEt.empresa);
        if(company !== undefined)this.setSelectedCompany(company);
    },
    async changeCompanySelected(){
        this.updateSelectedCompany();
        if (this.filtroEt.empresa) {
          this.country_id = null;
          await this.loadCompanyGeo({ company_id: this.filtroEt.empresa, country_id: null });

          // Aplicar selección automática después de cargar el árbol
          if (this.locations_user && this.locations_user.length > 0) {
            const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(this.filtroEt.empresa, this.locations_user, null, this.my_company);
            if (selectedLocationIds && selectedLocationIds.length > 0) {
              this.setFiltro({
                slq_locations_id: selectedLocationIds,
                ubicacion_diligenciada: null,
              });
            }
          }
        }
    },
    ...mapActions("tickets", [
      "listarTickets",
      "setPagePagination",
      "perPage",
      "getEstados",
      "getUsuarios",
      "getEmpresas",
      "setPerPagePagination",
      "fetchTicketsReport",
      "getTicketsReports",
      "geTicketInfoForGraphs",
      "getMyCompany"
    ]),
    ...mapMutations("tickets", [
      "setFiltro",
      "cambiaTicketId",
      "setLoading",
      "resetFiltro",
      "setPage",
      "setEmpresas",
      "setTicketsSeleccionados",
      "setMarcarCheckTodos",
      "setMarcarDesmarcarTodos",
      "setDefaultTicketsSeleccionados",
      "setPageMasivo",
      "setMensajesMasivos",
      "setRol",
      "setSelectedCompany"
    ]),
    ...mapMutations("dashboard", ["load"]),
    ...mapMutations("location", ["resetLocations"]),
    ...mapActions("accidents_high", [
      "getProducerByName",
    ]),
  },
  watch: {
    "filtroEt.empresa": function (id) {
      if (!id) {
        this.setArbolEmpresa({ data: [] });
        this.setFiltro({
          slq_locations_id: null,
          ubicacion_diligenciada: null,
        });
        this.loadCompanyGeo({ company_id: newVal, country_id: null });

        // Aplicar selección automática después de cargar el árbol
        this.$nextTick(async () => {
          if (this.locations_user && this.locations_user.length > 0) {
            const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(newVal, this.locations_user, null, this.my_company);
            if (selectedLocationIds && selectedLocationIds.length > 0) {
              this.setFiltro({
                slq_locations_id: selectedLocationIds,
                ubicacion_diligenciada: null,
              });
            }
          }
        });
      } else {
        this.country_id = null;
        this.resetLocations();
        this.setFiltro({
          slq_locations_id: null,
          ubicacion_diligenciada: null,
        });
      }
    },
    country_id(newVal) {
      if (this.filtroEt.empresa) {
        // limpiar siempre ubicaciones al cambiar país
        this.setFiltro({
          slq_locations_id: null,
          ubicacion_diligenciada: null,
        });

        // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
        if (this.locations_user && this.locations_user.length > 0) {
          const selectedLocationIds = this.loadLocationsTreeWithMultipleAutoSelect(this.filtroEt.empresa, this.locations_user, newVal || null, this.my_company);
          selectedLocationIds.then(ids => {
            if (ids && ids.length > 0) {
              this.setFiltro({
                slq_locations_id: ids,
                ubicacion_diligenciada: null,
              });
            }
          });
        } else {
          this.loadLocationsTree(this.filtroEt.empresa, newVal || null);
        }
      }
    },
    'filtroEt.hasta': function () {
      if (this.filtroEt.hasta < this.filtroEt.desde) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Los rangos de fechas para la busqueda son incorrectos',
          showConfirmButton: false,
          timer: 2000
        });
        this.filtroEt.hasta = null
      }

    },
  },
  computed: {
    ...mapState("tickets", [
      "esAdmin",
      "esEmpresa",
      "esSuperAdmin",
      "vistoUsuario",
      "tickets",
      "filtroEt",
      "marcadosPagina",
      "estadosBusqueda",
      "usuarios",
      "empresas",
      "ticketsSeleccionados",
      "tickets_chart",
      'typesOfMatters',
      "selectedCompany"
    ]),
    ...mapState("location", ["treeWithChildrens"]),
    ...mapState('autenticacion', ['usuarioAdmin','usuarioEmpresa','usuarioTecnico', 'my_company', 'locations_user']),
    ...mapState("accidents_high", [
      "producers",
    ]),
  },
};
</script>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
<style scoped>
.swal2-container {
  z-index: 4000;
}
.el-input__inner {
  height: 32px;
}

.el-date-editor .el-range-separator {
  line-height: 25px;
  width: 10%;
}

.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 100%;
}

.option:hover {
  cursor: pointer;
}
.width-select-options {
  width: 400px;
}
</style>
